var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpsideRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 388,
    height: 229,
    viewBox: "0 0 388 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M28 106.828C28 106.828 122.596 231.473 175.733 184.364C228.871 137.255 89.3897 -73.3248 202.772 67.0113C316.155 207.347 345.745 92.2424 351.46 76.7729C357.175 61.3034 351.46 -24 351.46 -24",
    stroke: "white",
    strokeWidth: 68
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpsideRight);
export default __webpack_public_path__ + "static/media/upside_right.a44c161ae147541ad2b4240a0c2f3ea2.svg";
export { ForwardRef as ReactComponent };